<template>
  <div class="onechart-info-container">
    <alert v-if="loading" class="mt-5 mx-4 shadow-card rounded" />
    <alert
      v-if="!encounter && !loading"
      class="mt-5 mx-4 shadow-card rounded"
      color="secondary"
      >Nothing to view...</alert
    >
    <div class="encounter-info" v-if="encounter">
      <div
        class="mb-5 border rounded p-2"
        v-for="document in encounter.documents"
        :key="document.id"
      >
        <h1 class="mt-2 mb-4 relative-position">
          {{ getDocumentType(document.note_type) }}
          <span
            class="alert status-alert py-2"
            :class="
              document.status == 'completed'
                ? 'alert5-success'
                : 'alert5-warning'
            "
            >{{ document.status }}</span
          >
        </h1>
        <div class="text-right copy-container px-2">
          <button
            class="btn btn-sm btn-link p-0 text-black copy-btn"
            @click="copyText(document.note_type)"
          >
            Copy <i class="fa-regular fa-copy"></i>
          </button>
          <span class="px-2" v-if="hasPermissionToEdit(encounter.note)">|</span>
          <button
            class="btn btn-sm btn-link p-0 text-black copy-btn"
            @click="editNote(encounter, false, document.note_type)"
            :disabled="encounter.note.editing"
            v-if="hasPermissionToEdit(encounter.note)"
          >
            Edit <i class="fa-regular fa-edit ml-1"></i>
          </button>
        </div>
        <div
          v-html="
            getDocumentText(
              document.description || 'The data will be available shortly.'
            )
          "
          :ref="'oneai-report-' + document.note_type"
        ></div>
        <div
          class="report-summary pt-4 border-top mt-4"
          v-if="encounter.note.editing && editingType == document.note_type"
          :ref="'oneai-edit-' + document.note_type"
        >
          <input-control
            type="horizontal"
            v-model="encounter.note.editingTitle"
            wrapClass="mt-3 mx-0"
            labelClass="d-none"
            placeholder="Title"
            >Title</input-control
          >
          <ckeditor
            :editor="editor"
            v-model="encounter.note.editingText"
            :config="editorConfig"
          >
          </ckeditor>

          <div class="d-flex justify-content-center pt-4">
            <button
              class="btn btn-deep-success"
              :disabled="encounter.note.saving"
              @click="!encounter.note.saving && saveNote(encounter.note, true)"
            >
              <span
                v-if="encounter.note.saving && encounter.note.approving"
                class="fa fa-spin fa-circle-notch mr-2"
              ></span>
              Save & Approve
            </button>
            <button
              v-if="!encounter.note.approved"
              class="btn btn-black ml-3"
              :disabled="encounter.note.saving"
              @click="!encounter.note.saving && saveNote(encounter.note)"
            >
              <span
                v-if="encounter.note.saving && !encounter.note.approving"
                class="fa fa-spin fa-circle-notch mr-2"
              ></span>
              Save
            </button>
            <button
              class="btn btn-danger ml-3"
              :disabled="encounter.note.saving"
              @click="
                !encounter.note.saving &&
                  editNote(encounter, true, document.note_type)
              "
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
      <div class="border rounded p-2">
        <h1 class="mt-2 mb-4 relative-position">
          Transcription
          <span
            class="alert status-alert py-2"
            :class="
              encounter.status == 'completed'
                ? 'alert5-success'
                : 'alert5-warning'
            "
            >{{ encounter.status }}</span
          >
        </h1>

        <div class="text-right copy-container px-2">
          <button
            class="btn btn-sm btn-link p-0 text-black copy-btn"
            @click="copyText('transcription')"
          >
            Copy <i class="fa-regular fa-copy"></i>
          </button>
          <span class="px-2" v-if="hasPermissionToEdit(encounter.note)">|</span>
          <button
            class="btn btn-sm btn-link p-0 text-black copy-btn"
            @click="editNote(encounter, false, 'transcription')"
            :disabled="encounter.note.editing"
            v-if="hasPermissionToEdit(encounter.note)"
          >
            Edit <i class="fa-regular fa-edit ml-1"></i>
          </button>
        </div>
        <div
          v-html="
            getDocumentText(
              encounter.transcription || 'The data will be available shortly.'
            )
          "
          ref="oneai-report-transcription"
        ></div>

        <div
          class="report-summary pt-4 border-top mt-4"
          v-if="encounter.note.editing && editingType == 'transcription'"
          ref="oneai-edit-transcription"
        >
          <input-control
            type="horizontal"
            v-model="encounter.note.editingTitle"
            wrapClass="mt-3 mx-0"
            labelClass="d-none"
            placeholder="Title"
            >Title</input-control
          >
          <ckeditor
            :editor="editor"
            v-model="encounter.note.editingText"
            :config="editorConfig"
          >
          </ckeditor>

          <div class="d-flex justify-content-center pt-4">
            <button
              class="btn btn-deep-success"
              :disabled="encounter.note.saving"
              @click="!encounter.note.saving && saveNote(encounter.note, true)"
            >
              <span
                v-if="encounter.note.saving && encounter.note.approving"
                class="fa fa-spin fa-circle-notch mr-2"
              ></span>
              Save & Approve
            </button>
            <button
              v-if="!encounter.note.approved"
              class="btn btn-black ml-3"
              :disabled="encounter.note.saving"
              @click="!encounter.note.saving && saveNote(encounter.note)"
            >
              <span
                v-if="encounter.note.saving && !encounter.note.approving"
                class="fa fa-spin fa-circle-notch mr-2"
              ></span>
              Save
            </button>
            <button
              class="btn btn-danger ml-3"
              :disabled="encounter.note.saving"
              @click="
                !encounter.note.saving &&
                  editNote(encounter, true, 'transcription')
              "
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      class="
        encounter-actions
        border-top
        d-flex
        flex-wrap
        justify-content-end
        mt-5
      "
      v-if="encounter"
    >
      <select-control
        v-model="selectedDocumentType"
        :options="documentTypeOptions"
        type="horizontal"
        selectClass="col-12 px-0 col-sm-auto mt-2 mt-sm-0"
        wrapClass="mb-0 ml-0 mr-2 col-12 col-sm-auto px-0 mt-3"
        labelClass="d-none"
        inputClass=""
      >
        Select Type:
      </select-control>
      <button
        class="btn btn-e27c1d mt-3 mr-3"
        @click="createDocument(encounter)"
        :disabled="saving"
      >
        <i class="fa fa-spin fa-circle-notch mr-2" v-if="saving"></i>
        Generate Document
      </button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { richTextConfig } from "../views/tasks/RichTextConfig";
import Swal from "sweetalert2";

export default {
  name: "OneChartInfo",
  props: ["note"],
  data() {
    return {
      encounter: null,
      loading: true,
      saving: false,
      editingType: "",
      documentOptions: [
        { label: "Select Document Type", value: "" },
        { label: "RBA Contact Note", value: "rba_contact_note" },
        { label: "General Office Note", value: "general_office_note" },
        { label: "RBA Clinical Note", value: "rba_clinical_note" },
        { label: "RBA Supervision Note", value: "rba_supervision_note" },
        { label: "Caregiver SOAP Note", value: "caregiver_soap_note" },
        {
          label: "General Engagement Note",
          value: "c3_general_engagement_note",
        },
        { label: "General Clinical Note", value: "c3_general_clinical_note" },
        { label: "Progress SOAP Note", value: "c3_progress_soap_note" },
        {
          label: "Client Resource Handout",
          value: "c3_client_resource_handout",
        },
        { label: "Patient Handout", value: "c3_patient_handout" },
        { label: "Prescription Note", value: "c3_prescription_note" },
        { label: "Consult Note", value: "consult_note" },
        { label: "Referral Letter", value: "referral_letter" },
        { label: "Physio", value: "physio" },
      ],
      selectedDocumentType: "",
      editor: richTextConfig.classicEditor,
      editorConfig: {
        placeholder: richTextConfig.placeholder,
        plugins: richTextConfig.plugins,
        ...richTextConfig.basicToolbar,
      },
    };
  },
  mounted() {
    this.initData();
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
    }),
    documentTypeOptions: function () {
      if (this.encounter && this.encounter.documents) {
        const keysToRemove = this.encounter.documents.map((d) => d.note_type);
        return this.documentOptions.filter(
          (option) => !keysToRemove.includes(option.value)
        );
      }
      return this.documentOptions;
    },
  },
  methods: {
    ...mapActions({
      getEncounter: "oneai/getEncounter",
      createOneAiDocument: "oneai/createOneAiDocument",
      editEngagementNote: "patients/editEngagementNote",
    }),
    initData() {
      if (this.note) {
        this.loading = true;
        this.getEncounter(this.note.encounter_id).then((data) => {
          this.encounter = data;
          this.loading = false;
        });
      }
    },
    getDocumentType(documentType) {
      return (
        this.documentOptions.filter((type) => type.value == documentType)[0] ||
        {}
      ).label;
    },
    getDocumentText(text) {
      let newText = text || "";
      newText = newText.replace(/\*\*(.*?)\*\*/g, (_, p1) => {
        return `<strong>${p1}</strong>`;
      });

      return newText
        .replace(/\n/g, "<br>")
        .replace(/(Speaker \d+:)/g, "<strong>$1</strong>");
    },
    createDocument(encounter) {
      if (!this.selectedDocumentType) {
        return Swal.fire({
          title: "Validation Error",
          text: "Document Type is missing",
          icon: "error",
        });
      }
      this.saving = true;
      this.createOneAiDocument({
        id: encounter.id,
        note_type: this.selectedDocumentType,
      }).then((success) => {
        this.saving = false;
        if (success) {
          this.initData();
          this.selectedDocumentType = "";
          Swal.fire({
            title: "Success",
            text: `Document generation request has been submitted and is currently processing.`,
            icon: "success",
          });
        }
      });
    },
    hasPermissionToEdit(note) {
      if (this.user.isAdmin || this.user.isManagingAdmin) {
        return true;
      }
      return (
        !note.approved &&
        (this.user.isAdmin ||
          this.user.isManagingAdmin ||
          this.user.id == note.reporter.id)
      );
    },
    copyText(type = "") {
      let prefix = `oneai-report-`;
      let title = "The OneAI transcription has been copied to your clipboard.";
      if (type !== "transcription") {
        title = `The OneAI ${this.getDocumentType(
          type
        )} has been copied to your clipboard.`;
      }
      navigator.clipboard
        .writeText(
          (this.$refs[`${prefix}${type}`][0] || this.$refs[`${prefix}${type}`])
            .innerText
        )
        .then(
          function () {
            Swal.fire({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 5000,
              timerProgressBar: true,
              icon: "success",
              title,
            });
          },
          function (err) {
            console.error("Async: Could not copy report: ", err);
          }
        );
    },
    editNote(encounter, cancel = false, type = "") {
      this.editingType = type;
      const note = encounter.note;
      if (type == "transcription") {
        note.editingText = encounter.transcription;
      } else {
        note.editingText =
          encounter.documents.find((doc) => doc.note_type === type)
            ?.description || "";
      }
      note.editingTitle = note.title;
      note.selectedCodes = note.service_codes;
      note.appointment_id = note.appointment?.id;
      note.editing = !cancel;
      this.$forceUpdate();
      setTimeout(() => {
        this.scrollToElement(
          cancel ? `oneai-report-${type}` : `oneai-edit-${type}`,
          120
        );
      }, 100);
    },
    saveNote(note, approve = false) {
      let errorMessage = "";
      if (!note.editingTitle) {
        errorMessage = "Engagement note title can't be empty";
      } else if (!note.editingText) {
        errorMessage = "Engagement note message can't be empty";
      }

      if (errorMessage) {
        return Swal.fire({
          title: "Error",
          text: errorMessage,
          icon: "error",
        });
      }
      note.saving = true;
      note.approving = approve;
      this.$forceUpdate();
      this.editEngagementNote({
        id: note.id,
        userId: note.user.id,
        title: note.editingTitle,
        report: note.editingText,
        approved: approve,
        appointment_id: note.appointment_id,
        service_codes: note.selectedCodes,
      }).then((data) => {
        note.saving = false;
        note.approving = false;
        note.editing = false;
        this.$forceUpdate();
        if (data) {
          Swal.fire({
            title: "Success",
            text: "Engagement note has been edited successfully, please refresh the page to see the changes.",
            icon: "success",
          });
        }
      });
    },
    scrollToElement(id, offset = 20) {
      const element = this.$refs[id][0] || this.$refs[id];
      const top = element.offsetTop - offset;

      document.querySelector(".modal-body-container").scrollTo({
        top,
        behavior: "smooth",
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.status-alert {
  position: absolute;
  right: 8px;
  text-transform: capitalize;
  padding: 8px 16px;
  font-size: 15px;
}
.copy-container {
  background-color: var(--body-bg-color);
  margin-left: -6px;
  margin-right: -6px;
  margin-bottom: 12px;
}

.report-summary {
  overflow: hidden;
}
</style>
